import { cloneDeep } from 'lodash';
import { getActionStatusName } from '@/store/helpers';

export const customScoringRequestStatus = state => state.status[getActionStatusName('customScoringRequest')] || {};

export const campaignSettings = state => (campaignId) => {
  if (campaignId && state.campaigns[campaignId]) {
    return state.campaigns[campaignId];
  }

  return null;
};

export const publisherSettings = state => (campaignId, affiliateId) => {
  if (state.campaigns[campaignId]?.publishers && state.campaigns[campaignId]?.publishers[affiliateId]) {
    return state.campaigns[campaignId].publishers[affiliateId];
  }

  return state.campaigns[campaignId];
};

export const setupVal = state => (campaignId) => {
  return GetProperty(state, campaignId, null, 'setupVal', false);
};

export const campaignSettingsOverride = state => (campaignId, affiliateId) => {
  if (affiliateId) {
    return GetProperty(state, campaignId, affiliateId, 'campaignSettingsOverride', affiliateId === 'newAffiliate' ? true : false);
  }
};

export const rtbId = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'rtbId', '');
};

export const affiliateViewRtbId = state => (campaignId) => {
  return GetProperty(state, campaignId, '', 'id', '');
};

export const enabled = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'enabled', false);
};

export const payoutCapacity = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'capps', {});
};

export const sipOnly = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'sipOnly', false);
};

export const callerIdRequired = state => (campaignId, affiliateId) => {
  if (affiliateId) {
    const callerIdRequiredOverride = state.campaigns[campaignId]?.publishers ? state.campaigns[campaignId]?.publishers[affiliateId]?.callerIdRequiredOverride : null;

    if (callerIdRequiredOverride != null) {
      return callerIdRequiredOverride;
    }
  }

  return GetProperty(state, campaignId, affiliateId, 'callerIdRequired', false);
};

export const icp = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'icp', 'Off');
};

export const journayaTcpa = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'journayaTcpa', 'Off');
};

export const trustedForm = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'trustedForm', 'Off');
};

export const trustedFormIntegration = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'trustedFormIntegration', {integrationMethod: 'Claim'});
};

export const trustedFormSettings = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'trustedFormSettings', {apiKey: null, certificateTagName: null});
};

export const jornayaSettings = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'jornayaSettings', {accountCode: null, auditKey: null, agencyCode: null});
};

export const bidExpirationInSeconds = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'bidExpirationInSeconds', '');
};

export const routeCallsForStaleBids = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'routeCallsForStaleBids', false);
};

export const rateLimitOverride = state => (campaignId, affiliateId) => {
  if (affiliateId) {
    return GetProperty(state, campaignId, affiliateId, 'rateLimitOverride', false);
  }
};

export const maxRequests = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'maxRequests', '');
};

export const perSeconds = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'perSeconds', 'Per Minute');
};

export const bidSettingsOverride = state => (campaignId, affiliateId) => {
  if (affiliateId) {
    return GetProperty(state, campaignId, affiliateId, 'bidSettingsOverride', false);
  }
};

export const baseBidAmount = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'baseBidAmount', '');
};

export const maxBidAmount = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'maxBidAmount', '');
};

export const minBidAmount = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'minBidAmount', '');
};

export const conversionType = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'conversionType', 'Inbound Call');
};

export const startTimerEvent = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'startTimerEvent', 'OnIncomingCall');
};

export const callLengthInSeconds = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'callLengthInSeconds', '');
};

export const secondsFromLastCall = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'secondsFromLastCall', 0);
};

export const passThroughBid = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'passThroughBid', {enabled: false, allowBidsAtLoss: false});
};
export const passThroughBidOverride = state => (campaignId, affiliateId) => {
  if (affiliateId) {
    return GetProperty(state, campaignId, affiliateId, 'passThroughBidOverride', false);
  }
};
export const passThroughBidOverrideValues = state => (campaignId, affiliateId) => {
  if (affiliateId) {
    return {
      maxBid: GetProperty(state, campaignId, affiliateId, 'maxBid', ''),
      bidMarginPercentage: GetProperty(state, campaignId, affiliateId, 'bidMarginPercentage', ''),
      bidMarginAmount: GetProperty(state, campaignId, affiliateId, 'bidMarginAmount', ''),
      minBidMarginPercentageAfterAdjustments: GetProperty(state, campaignId, affiliateId, 'minBidMarginPercentageAfterAdjustments', ''),
      minBidMarginAmountAfterAdjustments: GetProperty(state, campaignId, affiliateId, 'minBidMarginAmountAfterAdjustments', ''),
      allowBidsAtLoss: GetProperty(state, campaignId, affiliateId, 'allowBidsAtLoss')
    };
  }
};
export const minDurationAdjustments = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'minDurationAdjustments', []);
};
export const minDurationAdjustmentsOverride = state => (campaignId, affiliateId) => {
  if (affiliateId) {
    return GetProperty(state, campaignId, affiliateId, 'minDurationAdjustmentsOverride', []);
  }
};



export const customScoring = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'customScoring', {
    state: 'Off',
    customIntegrationType: 'score',
    scoreSettingsV2: {
      url: '',
      method: 'get',
      body: '',
      headers: {},
    },
    scoringSettingV2Migrated: true
  });
};

export const customScoringModified = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'customScoringModified', false);
};

export const hasCustomScoringV1 = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'hasCustomScoringV1', false);
};

export const bidAdjustmentsOverride = state => (campaignId, affiliateId) => {
  if (affiliateId) {
    return GetProperty(state, campaignId, affiliateId, 'bidAdjustmentsOverride', false);
  }
};

export const bidAdjustments = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'bidAdjustments', []);
};

export const rows = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'rows', []);
};

export const rowsPreviousState = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'rowsPreviousState', []);
};

export const getTags = state => (campaignId, affiliateId) => {
  if (affiliateId && state.campaigns[campaignId]?.publishers[affiliateId]?.bidAdjustmentsOverride) {
    return state.campaigns[campaignId]?.publishers[affiliateId]?.tags;
  }

  return state.campaigns[campaignId]?.tags;
};

export const GetProperty = (state, campaignId, affiliateId, property, valueIfNotFound) => {
  if (!state.campaigns || !campaignId || !state.campaigns[campaignId]) {
    return valueIfNotFound;
  } else if (affiliateId) {
    if (state.campaigns[campaignId].publishers && state.campaigns[campaignId].publishers[affiliateId]) {
      const pubProperty = state.campaigns[campaignId].publishers[affiliateId][property];
      return (pubProperty != null && typeof(pubProperty) != 'undefined') ? state.campaigns[campaignId].publishers[affiliateId][property] : cloneDeep(state.campaigns[campaignId][property]);
    }
    return valueIfNotFound;
  } else if (state.campaigns[campaignId][property] != null && typeof(state.campaigns[campaignId][property]) != 'undefined') {
    return cloneDeep(state.campaigns[campaignId][property]);
  } else {
    return valueIfNotFound;
  }
};